import { createAsyncThunk } from '@reduxjs/toolkit';
import { Policy } from 'src/types/policyTypes';
import {
	FetchPoliciesPayload,
	FetchConsentPayload,
	CreatePolicyPayload,
	UpdatePolicyPayload,
	UpdatePrioritiesPayload,
} from '../../../types/policyEngineTypes';

export const fetchPolicyFeeds = createAsyncThunk<
	Policy[],
	FetchPoliciesPayload,
	{ rejectValue: string }
>('policyEngine/fetchFeeds', async ({ api, accountId, search }, { rejectWithValue }) => {
	try {
		const response = await api.getPolicyEngineFeeds(accountId, search);
		return response?.data || [];
	} catch (error) {
		console.error('Failed to fetch policy feeds:', error);
		return rejectWithValue('Failed to fetch policy feeds');
	}
});

export const fetchConsent = createAsyncThunk<
	boolean,
	FetchConsentPayload,
	{ rejectValue: string }
>('policyEngine/fetchConsent', async ({ api, accountId }, { rejectWithValue }) => {
	try {
		const response = await api.getConsent(accountId);
		return response;
	} catch (error) {
		console.error('Failed to fetch consent:', error);
		return rejectWithValue('Failed to fetch consent');
	}
});

export const createPolicy = createAsyncThunk<
	Policy,
	CreatePolicyPayload,
	{ rejectValue: string }
>('policyEngine/createPolicy', async ({ api, accountId, payload }, { rejectWithValue }) => {
	try {
		const newPolicy = await api.createPolicy(accountId, payload);
		return newPolicy;
	} catch (error) {
		console.error('Failed to create policy:', error);
		return rejectWithValue(`Error on creating the ${payload.name}! Please try again after sometime.`);
	}
});

export const updatePolicy = createAsyncThunk<
	Policy,
	UpdatePolicyPayload,
	{ rejectValue: string }
>('policyEngine/updatePolicy', async ({ api, accountId, payload, policyId }, { rejectWithValue }) => {
	try {
		const response = await api.updatePolicyFeed(accountId, payload, policyId);
		return response.data;
	} catch (error) {
		console.error('Failed to update policy:', error);
		return rejectWithValue(`Error on updating the ${payload.name}! Please try again after sometime.`);
	}
});

export const updatePriorities = createAsyncThunk<
	{ skipToast?: boolean },
	UpdatePrioritiesPayload,
	{ rejectValue: string }
>('policyEngine/updatePriorities', async ({ api, accountId, priorities, skipToast }, { rejectWithValue }) => {
	try {
		if (priorities.length > 0) {
			await api.updatePolicyEngineFeedPriorities(accountId, priorities);
		}
		return { skipToast };
	} catch (error) {
		console.error('Failed to update priorities:', error);
		return rejectWithValue('Error on updating priorities! Please try again after some time.');
	}
});
